import { Button } from '@change/ds-core-ui/Button';
import { cn } from '@change/ds-utils';

import { EmailVerificationModal, LoginModal } from '#src/app/shared/components/payments';

import {
	Headline,
	HighAmountConfirmationModal,
	ImpressionAmountSelector,
	ImpressionCalculation,
	OverwritePaymentMethodConfirmationModal,
	PaymentMethods,
	PolicyInfo,
	PublicInput,
	ShouldSavePaymentMethodInput,
} from '../components';

import { useContainer } from './hooks/useContainer';

type Props = {
	buttonLabel: string;
};

export const PromoteFormContainer: React.FC<Props> = ({ buttonLabel }) => {
	const {
		data: { formRevealed, ref },
		actions: { handlePromoteClick },
	} = useContainer();

	return (
		<>
			<Button
				as="button"
				variant="primary"
				onClick={handlePromoteClick}
				className={cn('w-full text-center', { hidden: formRevealed })}
				data-qa="promote-button"
			>
				{buttonLabel}
			</Button>
			<div
				ref={ref}
				className={cn('border-fill-interactive flex w-full flex-col gap-6 rounded-lg border-2 p-6', {
					hidden: !formRevealed,
				})}
				data-testid="promote-form-container"
				tabIndex={-1}
			>
				<Headline />
				<div className="flex flex-col gap-2">
					<ImpressionAmountSelector />
					<ImpressionCalculation />
				</div>
				<PaymentMethods />
				<div className="flex flex-col gap-1">
					<ShouldSavePaymentMethodInput />
					<PublicInput />
				</div>
				<div className="text-start">
					<PolicyInfo />
				</div>
				<HighAmountConfirmationModal />
				<OverwritePaymentMethodConfirmationModal />
				<LoginModal />
				<EmailVerificationModal />
			</div>
		</>
	);
};
